import { createContext } from 'react';

// Define the type for the charge data
export type ClipboardItem = {
  id: string;
  contractChargeUnit: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
};

// Define the context type
export interface ClipboardContextType {
  copiedCharges: ClipboardItem[];
  setCopiedCharges: (charges: ClipboardItem[]) => void;
  clearCopiedCharges: () => void;
}

// Create the context with a default value
export const ClipboardContext = createContext<ClipboardContextType | undefined>(undefined);
